<div class="title-bar">
  <h2 mat-dialog-title>{{ "IMPERSONATION.MODAL.TITLE" | translate }}</h2>
</div>
<div mat-dialog-content>
  <p>
    {{ "IMPERSONATION.MODAL.MESSAGE" | translate }}
  </p>
</div>
<div mat-dialog-actions class="d-flex justify-content-end gap-4">
  <button
    mat-stroked-button
    color="primary"
    [mat-dialog-close]="false"
    cdkFocusInitial
  >
    {{ "IMPERSONATION.MODAL.EXIT" | translate }}
  </button>
  <button mat-raised-button color="primary" [mat-dialog-close]="true">
    {{ "IMPERSONATION.MODAL.CONFIRM" | translate }}
  </button>
</div>
